import React from 'react';

import styles from "./styles.module.scss"

const Cross = () => <span className={styles.cross}/>;

export default Cross;